<template>
  <el-dialog
    :id="$options.name"
    :before-close="noDialog"
    :fullscreen="dialogFullscreen"
    :visible.sync="dialog"
    title="提现"
  >
    <el-form
      ref="params"
      :model="params"
      :rules="withdrawRules"
      label-width="auto"
    >
      <el-form-item label="可提现金额"> {{ money }} 元 </el-form-item>
      <el-form-item label="金额" prop="money">
        <el-input v-model="params.money" placeholder="请输入金额" />
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input v-model="params.remark" maxlength="20" placeholder="选填" />
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="noDialog">取消</el-button>
      <el-button type="primary" @click="post">提交</el-button>
    </div>
  </el-dialog>
</template>

<script>
import agentWithdraw from "@/api/fund/withdraw-log-manage/agentWithdraw";
import agentWithdrawToBank from "@/api/fund/withdraw-log-manage/agentWithdrawToBank";
import agentWithdrawToDouGong from "@/api/fund/withdraw-log-manage/agentWithdrawToDouGong";
import dialogMixin from "@/mixin/dialogMixin";
import resDisposeMixin from "@/mixin/resDisposeMixin";

export default {
  name: "withdrawDialog",
  mixins: [dialogMixin, resDisposeMixin],
  props: {
    mode: String,
    money: Number,
    info: Object,
  },
  data() {
    const money = (rule, value, callback) => {
      let reg = /^[+-]?(0|([1-9]\d*))(\.\d+)?$/g;
      if (value === "") {
        callback(new Error("请输入内容"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入数字"));
      } else if (value > this.money) {
        callback(new Error("提现金额不能大于余额"));
      } else {
        callback();
      }
    };
    return {
      params: {
        money: undefined,
        remark: undefined,
      },
      withdrawRules: {
        money: [{ required: true, validator: money }],
      },
    };
  },
  methods: {
    post() {
      this.$refs["params"].validate((valid) => {
        if (valid) {
          // 驷马桥
          if (this.info.id == 68) {
            this.loadStart();
            if (this.mode === "card") {
              agentWithdrawToBank(this.params)
                .then((res) => {
                  this.resEditNoDialog({ res });
                })
                .finally(() => {
                  this.loadDialog.close();
                });
            } else if (this.mode === "weChat") {
              agentWithdraw(this.params)
                .then((res) => {
                  this.resEditNoDialog({ res });
                })
                .finally(() => {
                  this.loadDialog.close();
                });
            }
          } else {
            if (this.params.money > 20000) {
              this.$message.error("单笔提现金额不能超过两万元");
              return;
            }

            this.loadStart();
            agentWithdrawToDouGong(this.params)
              .then((res) => {
                this.resEditNoDialog({ res });
              })
              .finally(() => {
                this.loadDialog.close();
              });
          }
        }
      });
    },
  },
};
</script>
